<template>
    <div id="invoices-component">
        <form id="invoices_upload" class="animated fadeIn margin-al-inputs invoices_upload">
            <div v-for="(row, index) in selected_rows" :key="index">
                <input type="hidden" name="selected_rows_array[]" :value="row">
            </div>

            <!---VALORES POR DEFECTO QUE SE NECESITAN MANDAR -->
            <input type="hidden" name="is_sinister" :value="is_sinister">
            <input type="hidden" placeholder="role_id" name="role_id" class="required" :value="role_id">
            <input type="hidden" placeholder="type_invoice" name="type_invoice" :value="type_invoice">
            <input type="hidden" placeholder="supplier_id" name="supplier_id" class="required" :value="reg_id">
            <input type="hidden" placeholder="model_type" name="model_type" class="required" :value="model_type">

            <div class="row">
                <div class="col-12 col-sm-12">
                    <div class="alert alert-info text-center">
                        <p>Se debe seleccionar los dos archivos de la factura el XML y el PDF, ya que el XML es
                            validado ante el SAT para su validación, esto puede tomar algo de tiempo por favor sea
                            paciente.</p>
                        <p> Tome en cuenta que este proceso dependerá de su conexión a internet, se le recomienda
                            tener una conexión a internet de al menos 5 Mbps de subida.</p>
                    </div>
                    <div class="col-12 col-sm-4 offset-sm-4" v-if="auth_role===1">
                        <div class="float" style="font-size:14px; text-align: right;">Comparar codigo del SAT</div>
                        <div class="float" style="margin:0 0 0 10px; width:70px;">
                            <input type="checkbox" name="match_sat" hidden="hidden" id="match_sat">
                            <label class="switch" for="match_sat"></label>
                        </div>
                    </div>
                    <span class="btn btn-default btn-file">
                        Cargar Archivos de Facturas
                        <input type="file"
                               accept=".xml,.pdf"
                               name="facturas[]"
                               id="file_factura"
                               multiple data-label="facturas"
                               class="required"
                               v-on:change="getBills">
                    </span>
                    <span class="label-file-papeleria alert alert-info factura_name"></span>
                    <button id="dyn-button" class="btn btn-primary" type="button" v-on:click="guardar()">
                        {{ tituloBtn }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {invoicesService} from "../../Services/Invoices.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "Invoices",
    mixins: [myMixins],
    props: {
        is_quoter: {
            type: Boolean,
            comments: 'Es para saber si la factura viene una cotizacion',
            required: false,
            default: false
        },
        role_id: {
            type: Number,
            comments: 'Es el rol del usuario que esta cargando la factura, se usa para obtener el directorio donde se guarda el archivo de la factura',
            required: true
        },
        reg_id: {
            type: Number,
            required: false,
            comments: 'Es el id que se va a registrar en supplier_id  en la tabla invoices',
            default: 0
        },
        type_invoice: {
            type: Number,
            required: false,
            comments: 'Es el tipo de factura 1:honorarios, 2:servicios extras ',
            default: 0
        },
        selected_rows: {
            type: Array,
            required: false,
            comments: 'Es un array de facturas que lleva el id del registro y el supplier_id, esto es para cualquier proveedor y suba varios siniestros con 1 factura, este array lleva el reg_id y el supplier_id',
            default: function () {
                return []; // Puedes inicializar con el valor predeterminado que desees
            }
        },
        auth_role: {
            type: Number,
            required: false,
            comments: 'Es el id del usuario que esta autenticado',
            default: 0
        },
        is_sinister: {
            type: Boolean,
            required: false,
            comments: 'Es para saber si la factura viene de un siniestro',
        },

    },
    data() {
        return {
            filter: null,
            modalShow: false,
            isBusy: false,
            modificar: false,
            path_storage: '',
            model_type: '',
            facturas: [],
            tituloBtn: 'Subir',
            billId: 0,
        }
    },
    methods: {
        //let columnName = this.columnMapping[Number(id)];
        async onClickDelete(id) {
            let resp = await invoicesService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('invoices_upload');
            this.disableSubmitBtn(true);
            //console.log('respVal', respVal);
            if (respVal) {
                //console.log('enviando factura');
                const formData = getFormData('invoices_upload');
                resp = await invoicesService.saveOne(formData, {
                    isForm: true,
                    onUploadProgress: this.onUploadProgress
                });
            }
            this.disableSubmitBtn(false);
            this.showModal = false;
            this.getAlert(resp.process, true);
        },
        getBills() {

            // Obtén los archivos cargados
            let files = event.target.files;

            // Verifica si se cargaron exactamente dos archivos
            if (files.length !== 2) {
                //alert('Por favor, carga exactamente dos archivos.');
                this.getAlert('less_files');
                return;
            }

            // Verifica si los archivos son PDF y XML
            let fileTypes = Array.from(files).map(file => file.type);
            //console.log('fileTypes', fileTypes);
            if (!fileTypes.includes('application/pdf') || !fileTypes.includes('text/xml')) {
                this.getAlert('no_match_files');
                //alert('Por favor, carga un archivo PDF y un archivo XML.');
                return;
            }

            //console.log('getNameFile');
            this.getNameFile(event, 'factura_name');

        },

    },
    mounted() {
        if (this.is_quoter) {
            this.model_type = 'Quoting';
        } else {
            this.model_type = this.roleModels[this.role_id];
        }
        console.log('this.is_sinister', this.is_sinister);
    }

}
</script>

